import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const AdminUserService = {};
AdminUserService.downloadTemplate = async () => {
  return axios({
    method: "get",
    url: API_BASE_URL + "/api/admin/user/download/generate-template",
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
    responseType: "blob",
  });
};
AdminUserService.generateAccounts = async function (file) {
  let data = new FormData();
  data.append("file", file);

  return axios({
    method: "post",
    url: API_BASE_URL + `/api/admin/user/generate/accounts`,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
    responseType: "blob",
  });
};
export default AdminUserService;
